var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"html-container"},[_c('iframe',{attrs:{"src":"/waple/chatbot.html","width":"100%","height":"100%","frameborder":"0"}})])}]

export { render, staticRenderFns }